import React, {Component} from 'react';
import FeedContainer from './feed_container'
import TestButtons from '../../Templates/test_container'
import {checkDevKeys} from '../../Templates/functions'
// import NavigationThumbnails from "../../Templates/legacy/NavigationThumbnails"
class HomePage extends Component {
    state = {
        displayTestButtons: false,
    }

    //lifecycle methods

    componentDidMount = () => {
        document.addEventListener("keydown", this.devCheck)
    }

    componentWillUnmount = () => {
        document.removeEventListener("keydown", this.devCheck)
    }

    devCheck = (e) => {
        checkDevKeys(e.keyCode, this.state.devKeyPresses, (value) => this.setState({ devKeyPresses: value}), () => this.setState(prevState => ({displayTestButtons: !prevState.displayTestButtons})) )
    }

    render = () => (
        <div className="home-container max-width">
            {/* <NavigationThumbnails /> */}
            {this.state.displayTestButtons ? <TestButtons /> : null}
            <FeedContainer />
        </div>
    )
}

export default HomePage